<template>
    <div :class="lightMood ? 'q-containerCopy' : 'q-container'">
        <div class="d-flex justify-content-between add-weight-section">
            <QuestionWeight :template="template" type="rank"/>
            <!-- <span @click="clearHandler" class="reset-data-btn">Reset All</span> -->
        </div>
        <div v-for="(q, idx) in template?.questions?.rank?.questions"
             :key="idx"
             class="rank-q-body q-body  d-flex  flex-column justify-content-start">
            <div class="d-flex flex-column gap-3">

                <div class="d-flex gap-4">
                    <div class="d-flex flex-column w-100 position-relative question-container">
                        <QuestionComponent :id="'rank-q'+idx" :template="template" type="rank" :index="idx"
                                           :validationCB="rankQuestionsValidation"/>
                        <div class="d-flex gap-3">
                            <div class=" w-75">
                                <div class="err w-75" v-if="q.errors['question'].length > 0">
                                    <div v-for="msg in q.errors['question']" class="text-danger">{{msg}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="align-self-end add-question-icon"
                         v-if="(template.questions.rank.questions.length - 1) === idx">
                        <span class="add-question align-self-end"
                              @click="addQuestionHandler($event, 'rank')">+</span>
                    </div>
                </div>
                <div class="rate-header">
                    Rate
                </div>
                <div class="d-flex rate-answer-section ">
                    <div v-for="(a,index) in q.answers" class="d-flex gap-3 answers-container">
                        <input @click="checkHandler($event, idx, index)"
                               :id="'rankQ'+idx+'-'+index" type="radio"
                               :name="'rank-'+idx"
                               :value="true"
                               v-model="a.is_correct" class="form-check-input"/>
                        <label :for="'rankQ'+idx+'-'+index" class="form-check-label">{{a.value}}</label>
                    </div>
                </div>
            </div>

            <div class="d-flex gap-3">
                <div>
                    <div class="err" v-if="q.errors['answers'].length > 0">
                        <div v-for="msg in q.errors['answers']" class="text-danger">{{msg}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <ConfirmationModal v-if="confirmFlag" :message="confirmMsg" confirmBtn="Yes" cancleBtn="No"
                       @close-modal="confirmModalHandler($event)"/>
    <span v-if="lightMood"></span>
</template>


<script>
    import {defineAsyncComponent, toRef, ref, computed} from "vue";
    import QuestionWeight from "../../components/QuestionWeight";
    import QuestionComponent from "../../components/templateComponents/questionComponent";

    const ConfirmationModal = defineAsyncComponent(() =>
        import ('../../components/ConfirmationModal')
    );
    import increaseTemplateQuestions from "../../../helpers/increaseTemplateQuestionsCounter";
    import decreaseTemplateQuestions from "../../../helpers/decreaseTemplateQuestionsCounter";
    import qustionValidation from "../../../validation/qustionValidation";
    import {useStore} from "vuex";

    export default {
        name: 'app',

        props: {
            template: Object
        },
        components: {QuestionWeight, QuestionComponent, ConfirmationModal},

        setup(props, context) {
            const store = useStore();
            const confirmFlag = ref(false);
            const confirmMsg = ref('');

            const template = toRef(props, 'template');
            const lightMood = computed({
                get() {
                    return store.state.settings.isLightMood;
                },
            });

            const checkHandler = (e, qIdex, aIdx) => {
                let errors = null;
                let element = template.value.questions.rank.questions[qIdex];
                console.log(qIdex, aIdx)
                // template.value.questions.rank.questions[qIdex].errors['answers'] = [];


                // template.value.questions.rank.questions[qIdex].answers.forEach((answer, idx) => {
                //     if (idx !== aIdx) {
                //         answer.is_correct = false;
                //     } else {
                //         answer.is_correct = true;
                //     }
                // });

                errors = rankQuestionsValidation(element);
                if (!errors)
                    increaseTemplateQuestions(template, 'rank');
                else
                    decreaseTemplateQuestions(template, 'rank');


            };


            const addQuestionHandler = (e, type) => {

                let length = template.value.questions[type].questions.length;
                let lastElement = template.value.questions[type].questions[length - 1];
                let isErrors = false;
                let question = null;

                isErrors = rankQuestionsValidation(lastElement);

                question = {
                    question: '',
                    answers: [
                        {value: 1, is_correct: false}, {value: 2, is_correct: false}, {value: 3, is_correct: false},
                        {value: 4, is_correct: false}, {value: 5, is_correct: false}, {value: 6, is_correct: false},
                        {value: 7, is_correct: false}, {value: 8, is_correct: false}, {value: 9, is_correct: false},
                        {value: 10, is_correct: false}
                    ],
                    isDelete: true,
                    errors: {
                        question: [],
                        answers: []
                    }
                };

                if (!isErrors) {
                    addNewQuestionData(question, type)
                }
            };


            const confirmModalHandler = (e) => {
                confirmFlag.value = false;
                if (e) {
                    template.value.questions['rank'].questions = [{
                        question: '',
                        answers: [
                            {value: 1, is_correct: false}, {value: 2, is_correct: false}, {value: 3, is_correct: false},
                            {value: 4, is_correct: false}, {value: 5, is_correct: false}, {value: 6, is_correct: false},
                            {value: 7, is_correct: false}, {value: 8, is_correct: false}, {value: 9, is_correct: false},
                            {value: 10, is_correct: false}
                        ],
                        isDelete: true,
                        errors: {
                            question: [],
                            answers: []
                        }
                    }];
                    if (template.value.questions['rank'].counter > 0) {
                        template.value.questions['rank'].counter = 0;
                        template.value.questionsCount -= 1;
                    }

                    template.value.questions['rank'].isError = false;
                }
            };

            const clearHandler = () => {
                template.value.questions['rank'].weight = null;
                template.value.questions['rank']['errors']['weight']['isError'] = false;
                template.value.questions['rank']['errors']['weight']['message'] = '';

                if (template.value.questions['rank'].counter > 0 || template.value.questions['rank'].isError) {
                    confirmFlag.value = true;
                    confirmMsg.value = 'Are you sure you want to reset data?';
                }
            };

            const deleteQuestionHandler = (idx, type) => {
                let errors = null;

                console.log({idx})
                let element = template.value.questions.rank.questions[idx - 1];

                template.value.questions[type].questions.splice(idx, 1);

                errors = rankQuestionsValidation(element);
                // if (!errors)
                //     decreaseTemplateQuestions(template, 'trueOrFalse');
            };

            const rankQuestionsValidation = (element) => {

                if (process.env.VUE_ENV === 'development')
                    console.log({element})
                let BreakException = {};

                let isErrors = {
                    question: false,
                    answers: false,
                };

                if (template.value.questions['rank'].weight === null) {
                    template.value.questions['rank']['errors']['weight']['isError'] = true
                    template.value.questions['rank']['errors']['weight']['message'] = '*Required'
                }

                isErrors.question = qustionValidation(element);

                // try {
                //     element.answers.forEach((ans) => {
                //         if (ans.is_correct === true) {
                //             element.errors['answers'] = [];
                //             isErrors.answers = false;
                //             throw BreakException;
                //         } else {
                //             element.errors['answers'] = ['* required'];
                //             isErrors.answers = true;
                //         }
                //     });
                // } catch (e) {
                //     if (e !== BreakException) throw e;
                // }
                isErrors = isErrors.question || isErrors.answers;

                template.value.questions['rank'].isError = isErrors;
                return isErrors;
            };

            const addNewQuestionData = (question, type) => {
                template.value.questions[type].questions.push(
                    question
                )
            };

            const checkErrors = (idx) => {
                let retVale = true;
                let errors = template.value.questions.rank.questions[idx].errors;
                let weightError = template.value.questions.rank.errors.weight;
                if (errors.question.length === 0 && errors.answers.length === 0 && !weightError) {
                    retVale = false;
                }
                return retVale;
            };

            return {
                template,
                confirmMsg,
                confirmFlag,
                checkHandler,
                lightMood: computed(() => store.state.settings.isLightMood),
                clearHandler,
                addQuestionHandler,
                deleteQuestionHandler,
                rankQuestionsValidation,
                addNewQuestionData,
                checkErrors,
                confirmModalHandler,
                increaseTemplateQuestions,
                decreaseTemplateQuestions
            }
        }
    }

</script>

<style scoped>
    .add-weight-section{
        margin-bottom: 20px;
    }
    .add-question-icon{
        margin-bottom: 27px;
    }
    .rate-header{
        font-size:16px;
        font-weight: 600;
    }
    .rate-answer-section{
        gap:5rem;
        padding-left: 5px;
        margin-bottom: 10px;
    }
    .add-question {
        font-size: 18px;
        font-weight: 500;
        cursor: pointer;
        color: #e65c00;
        border: 1px solid;
        border-radius: 50%;
        width: 25px;
        height: 25px;
        display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;
    }

    .add-question:hover {
        background-color: #e65c00;
        color: #032a3a;
    }

    .q-container {
        overflow-y: auto;
        padding: 20px;
        /* margin-top: 12px; */
        background-color: #032A3A;
        border-radius: 0 0 5px 5px;
        height: 100%;
    }

    .q-containerCopy {
        overflow-y: auto;
        padding: 20px;
        /* margin-top: 12px; */
        /*background-color: #032A3A;*/
        border-radius: 0 0 5px 5px;
        height: 100%;
    }

    .rank-q-body {
        height: 170px;
    }
    .q-body{
        overflow: unset;
        margin-bottom: 50px;
    }
    .q-input {
        background-color: transparent !important;
        border: 1px solid #39525C;
        border-radius: 4px;
        height: 65px;
        color: #FFF;
        padding: 10px;
    }

    .q-input:focus,
    .q-input:focus-visible {
        outline: 0;
    }

    .form-check-input {
        border: 1px solid white !important;
        background-color: transparent !important;
    }

    .form-check-input:checked {
        background-image: url("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10l3 3l6-6%27/%3e%3c/svg%3e") !important;
        border: 2px solid white !important;;
        /* background-color: #e95626 !important; */
        box-shadow: 0 0 0 1px white !important;
    }

    .add-question {
        cursor: pointer;
        color: #e65c00;
    }

    .m-c-answer-container > input[type=text],
    .m-c-answer-container > input[type=text]:focus,
    .m-c-answer-container > input[type=text]:focus-visible {
        border: 0;
        color: #FFF;
        background-color: transparent;
        outline: 0;
    }

    .question-container{
        width: 100%;
        height: 100px;
    }

    .answers-container{
        pointer-events: none;
        border:1px solid #39525C;
        padding:10px 15px;
        border-radius:5px;
    }
</style>